import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';
import React from 'react';

const CaptionLinkTypography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, children, truncate = true, ...props }, ref) => (
		<h4
			ref={ref}
			className={cn(`scroll-m-20 ${truncate ? 'truncate' : ''} text-xs font-medium underline`, className)}
			{...props}
		>
			{children}
		</h4>
	)
);

CaptionLinkTypography.displayName = 'CaptionLinkTypography';

export default CaptionLinkTypography;
